import type { PriceNegotiationRow } from './priceNegotiationProduct';

import { CANNED_TALLY_LENGTH_ID } from '~/pages/order-builder/sections/lengthSelection';

export function orderBuilderUrl(
  negotiation: PriceNegotiationRow,
  returnPath: string
): string | null {
  const length = negotiation.platformProductLength;
  if (length?.platformProduct?.id) {
    const params = new URLSearchParams({
      platformProductId: length.platformProduct.id,
      platformProductLengthId: length.id,
      returnPath,
    });
    return `/order-builder/view?${params.toString()}`;
  }

  const tallyProductId =
    negotiation.platformProductCannedTally?.platformProduct?.id;
  if (tallyProductId) {
    const params = new URLSearchParams({
      platformProductId: tallyProductId,
      platformProductLengthId: CANNED_TALLY_LENGTH_ID,
      returnPath,
    });
    return `/order-builder/view?${params.toString()}`;
  }

  return null;
}
